import { Shield, TrendingUp, Landmark, ArrowRight } from "lucide-react";

const cards = [
  {
    icon: Shield,
    title: "Protection",
    body: "Protect your family, income, and long-term future with modern life insurance.",
  },
  {
    icon: TrendingUp,
    title: "Wealth Building",
    body: "Strategies designed to help support tax-advantaged cash value growth.",
  },
  {
    icon: Landmark,
    title: "Become Your Own Bank",
    body: "Access liquidity through properly structured policies — on your terms.",
  },
];

export default function WealthSection() {
  return (
    <section
      id="protection"
      data-testid="wealth-protection-section"
      className="relative py-24 md:py-40 overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[80vw] h-[80vw] ambient-radial pointer-events-none opacity-50"
      />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl reveal">
          <div className="text-[11px] uppercase tracking-[0.28em] text-rolex-light mb-6">
            Wealth & Protection
          </div>
          <h2 className="font-serif font-light text-white text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-balance">
            Insurance designed{" "}
            <span className="italic text-rolex-light">beyond</span> just
            protection.
          </h2>
          <p className="mt-8 text-lg text-gray-400 max-w-2xl leading-relaxed font-light">
            Protection, wealth-building, and financial flexibility combined into
            one modern strategy.
          </p>
        </div>

        <div id="wealth" className="mt-20 grid md:grid-cols-3 gap-6 lg:gap-8">
          {cards.map((c, i) => (
            <button
              key={c.title}
              data-testid={`wealth-card-${i}`}
              onClick={() => {
                const el = document.querySelector("#calendly-embed");
                if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
              }}
              className="reveal group relative rounded-3xl glass p-10 text-left transition-all duration-500 hover:-translate-y-1.5 hover:border-rolex/40 hover:bg-white/[0.05]"
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <div
                aria-hidden
                className="absolute -inset-px rounded-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"
                style={{
                  background:
                    "radial-gradient(120% 80% at 50% 0%, rgba(0,98,65,0.18), rgba(0,0,0,0) 60%)",
                }}
              />
              <div className="relative">
                <div className="flex items-center justify-center w-14 h-14 rounded-2xl bg-rolex/10 border border-rolex/30 mb-8">
                  <c.icon className="h-6 w-6 text-rolex-light" />
                </div>
                <h3 className="font-serif text-3xl text-white mb-4">{c.title}</h3>
                <p className="text-[15px] text-gray-400 leading-relaxed font-light">
                  {c.body}
                </p>
                <div className="mt-10 flex items-center gap-2 text-sm text-rolex-light/80 group-hover:text-rolex-light transition-colors">
                  <span className="uppercase tracking-[0.22em] text-[11px]">
                    Learn more
                  </span>
                  <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
